import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon_15.png'


const _withScopeId = n => (_pushScopeId("data-v-12d69a0f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-row-center-sb pl-20 ptb-20" }
const _hoisted_2 = { class: "fz-18 co-1F2D48 font-blod" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "wh-12",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "fz-15 co-1F2D48 pb-30 plr-20" }
const _hoisted_6 = { class: "flex-row-center-end pr-20 pb-20" }

import { ref, withDefaults } from 'vue';

	interface main {
		sureText ?: string,
		title ?: string,
	}

	
export default /*#__PURE__*/_defineComponent({
  __name: 'TipsPop',
  props: {
    sureText: { default: "确认" },
    title: { default: "提示" }
  },
  emits: ["change"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

	const props = __props;
	const emits = __emit;
	const pop = ref(false);
	const tips = ref("");

	const submit = () => {
		close();
		emits("change");
	};
	const open = (params : any) => {
		pop.value = true;
		tips.value = params;
	};
	const close = () => {
		pop.value = false;
	};

	__expose({
		open,
		close,
	});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_dialog, {
      modelValue: pop.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pop).value = $event)),
      title: "",
      width: "320px",
      "show-close": false,
      "destroy-on-close": "",
      "align-center": true
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(props.title), 1),
          _createElementVNode("div", {
            class: "pr-20 pointer",
            onClick: close
          }, _hoisted_4)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, _toDisplayString(tips.value), 1),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_button, {
            class: "cancel-btn",
            onClick: close
          }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            class: "sure-btn",
            type: "primary",
            onClick: submit
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(props.sureText), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})